module.exports = __webpack_public_path__ + "img/system.ab54eb8a.png";